import React from "react";
import { motion } from "framer-motion";
import { Mail, ArrowRight, Linkedin } from "lucide-react";
import PageMeta from "../site/PageMeta";
import Chapter from "../site/Chapter";

const CAREERS_MAILTO =
  "mailto:sahil@a4assist.com?subject=A4%20Assist%20—%20I%27d%20like%20to%20work%20with%20you";

export default function Careers() {
  return (
    <>
      <PageMeta
        title="Careers at A4 Assist — Reach Out"
        description="A4 Assist doesn't post open roles. Interested in working with us? Email sahil@a4assist.com with a bit about yourself and a link to your LinkedIn or resume."
      />

      <section className="pt-36 pb-14">
        <div className="max-w-[1400px] mx-auto px-6 sm:px-10">
          <Chapter
            number="00"
            eyebrow="Careers"
            title={
              <>
                We're always open to meeting{" "}
                <span className="font-serif italic">good</span> people.
              </>
            }
            subtitle="A4 Assist doesn't post open roles here. If you're interested in working with us — now or down the line — reach out and tell us a bit about yourself."
          />
        </div>
      </section>

      <section className="pb-28">
        <div className="max-w-3xl mx-auto px-6 sm:px-10">
          <motion.div
            initial={{ opacity: 0, y: 18 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.55 }}
            data-testid="careers-contact-card"
            className="relative rounded-2xl border border-slate-800 bg-gradient-to-br from-[#0A1325] to-[#070F1F] p-8 sm:p-10 overflow-hidden"
          >
            <div className="absolute -top-24 -right-16 h-56 w-56 rounded-full bg-[#A3FF5E]/10 blur-3xl" />

            <div className="relative">
              <div className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-[#00E5FF]/10 text-[#00E5FF] border border-[#00E5FF]/25">
                <Mail size={20} />
              </div>

              <p className="pull-quote mt-6 text-2xl sm:text-[26px] text-white/95 leading-snug max-w-2xl">
                Interested in working with us? Email{" "}
                <a
                  href={CAREERS_MAILTO}
                  data-testid="careers-email-link"
                  className="text-[#00E5FF] not-italic font-sans font-semibold hover:underline"
                >
                  sahil@a4assist.com
                </a>{" "}
                with a bit about yourself and a link to your LinkedIn or resume.
              </p>

              <div className="mt-8 flex flex-col sm:flex-row gap-3">
                <a
                  href={CAREERS_MAILTO}
                  data-testid="careers-mailto-cta"
                  className="group inline-flex items-center justify-center gap-2 bg-[#00E5FF] hover:bg-[#00E5FF]/90 text-[#050B14] font-semibold px-6 py-3.5 rounded-md shadow-[0_0_30px_-8px_rgba(0,229,255,0.6)]"
                >
                  Email sahil@a4assist.com
                  <ArrowRight size={16} className="arrow-shift" />
                </a>
                <a
                  href="https://www.linkedin.com/in/sahil-batra-97410059/"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="careers-linkedin-link"
                  className="inline-flex items-center justify-center gap-2 border border-slate-700 hover:border-[#00E5FF]/60 text-white font-semibold px-6 py-3.5 rounded-md"
                >
                  <Linkedin size={16} /> Connect on LinkedIn
                </a>
              </div>

              <p className="mt-8 pt-6 border-t border-slate-800 text-xs text-slate-500">
                We review every message. If there's a fit — now or later — we'll be in
                touch. There's no application deadline because there's no posted role
                to apply to.
              </p>
            </div>
          </motion.div>
        </div>
      </section>
    </>
  );
}
